import(/* webpackMode: "eager" */ "/vercel/path0/apps/terminal/app/ninx/page.tsx");
